import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY } from '../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SnPzn: [],
		SnDruh: [],
		Snzdrojdat: [],
		VyrobekvozOzn: [],
	},
	filter: {
		SnPzn: null as string | null,
		SnDruh: null as string | null,
		Snzdrojdat: null as string | null,
		VyrobekvozOzn: null as string | null,
		Text: null as string | null,
		PlatnostodDat: null as Date | null,
		PlatnostdoDat: null as Date | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
